<div class="db-product-item db-product-item_view_list product" [class.loading]="loading && !status">
  <div class="actions-wrap mr16">
    <input class="ds-checkbox" id="productItem_{{product.uid}}" type="checkbox"
           [class.ds-checkbox-disabled]="productsLoading || status"
           [checked]="product.selected"
           (change)="onProductToggled($event)">
    <label class="ds-checkbox-label purple" for="productItem_{{product.uid}}"></label>
  </div>
  <div class="db-product-item__info title-wrap mr32"
       [dsTooltipVisible]="product?.title?.trim()?.length > 33"
       [dsTooltipPosition]="'top'"
       [dsTooltipAlign]="'left'"
       [dsTooltipColor]="'black'"
       [dsTooltipSize]="'small'"
       [dsTooltip]="product.title">
    {{ product?.title?.trim()}}
  </div>
  <div class="product-version">
    {{ product.version }}
  </div>
  <div class="product-version">
    @if (!loading && !status) {
      <span class="db-product-item__show_changelog" (click)="updateItem.emit(product)">
        {{ 'text_updateVersion' | dbText:{version: product.paidVersionInstalled ? product.currentVersion.paid : product.currentVersion.free } }}
      </span>
    } @else if(status) {
      <span class="status">
        {{(status === 'failed' ? 'text_updateFailed' :'text_updated') | dbText }}
      </span>
    }@else{
      <span class="loading">
        <img src="assets/images/loading/spinner-dotted.svg">
          {{ 'text_themeUpdateProcess' | dbText }}
      </span>
    }
  </div>
</div>
